import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'

export type PileExecutionMode = 'drive' | 'prebore_only'

interface Props {
  isOpen: boolean
  isSubmitting?: boolean
  onClose: () => void
  onSelectMode: (mode: PileExecutionMode) => void
}

const ModeSelectionModal: React.FC<Props> = ({
  isOpen,
  isSubmitting = false,
  onClose,
  onSelectMode,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body

  return createPortal(
    <Modal
      id='kt_modal_pile_execution_mode'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={isOpen}
      onHide={onClose}
      backdrop={isSubmitting ? 'static' : true}
      keyboard={!isSubmitting}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>เลือกโหมดการดำเนินการ</h2>
          {!isSubmitting && (
            <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
            </div>
          )}
        </div>

        <div className='modal-body py-8'>
          <div className='d-flex flex-column gap-3'>
            <button
              type='button'
              className='btn btn-light-primary btn-lg fw-bold d-flex justify-content-between align-items-center'
              disabled={isSubmitting}
              onClick={() => onSelectMode('drive')}>
              <span>ตอกเสาเข็ม</span>
              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
            </button>

            <button
              type='button'
              className='btn btn-light-primary btn-lg fw-bold d-flex justify-content-between align-items-center'
              disabled={isSubmitting}
              onClick={() => onSelectMode('prebore_only')}>
              <span>Prebore เท่านั้น</span>
              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
            </button>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default ModeSelectionModal
